"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
require("../layout.sass");
var navbar_1 = __importDefault(require("../navbar/navbar"));
function Layout(props) {
    return (react_1.default.createElement("div", { className: 'layout' },
        react_1.default.createElement(navbar_1.default, null),
        react_1.default.createElement("div", { className: 'card' },
            react_1.default.createElement.apply(react_1.default, __spreadArray(["div", { className: 'container' }], props.children, false)))));
}
Layout.propTypes = {
    children: prop_types_1.default.any,
};
exports.default = Layout;
